import { actionSetScenePreloadState } from '../../state/scene/sceneActions';
import { Thunk } from '../../generalTypes';

const init: Thunk = () => dispatch => {
  dispatch(actionSetScenePreloadState(true));
};

export default init;
